module.exports = __webpack_public_path__ + "static/media/onetime_password_system_p.a3528ac2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/onetime_password_system_p.jpg
// module id = 359
// module chunks = 0